import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Formik, Form } from "formik";
import { toast } from 'sonner';
import { InitiateResetPasswordSchema } from '../../utils/yupSchemas';
import { FaLongArrowAltRight } from "react-icons/fa";
import { TextInput } from '../../components/forms/inputs';
import { useSendAuthRequest } from '../../hooks/post/useSendAuthRequest';
import { apiPaths } from '../../config/api-urls';
import { Button } from '../../components/button';
import { PageURL } from '../../config/page-urls';

const InitiateResetPassword = () => {

    const sendAuthRequest = useSendAuthRequest();
    const navigateTo = useNavigate();
  return (
    <div className='h-screen w-full flex justify-center items-center'>
        <div className='w-11/12 md:w-4/12'>

            <Formik
                initialValues={{ email: "" }}
                validationSchema={InitiateResetPasswordSchema}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        const payload = {
                            email: values.email
                        }
                    const { status, data } = await sendAuthRequest(apiPaths.initiateResetPassword, payload);
                    if(status===200){
                        navigateTo(PageURL.initiateResetPasswordResetSuccess, { state: payload });
                        toast.success(data.message)
                    }
                    setSubmitting(false);
                    } catch (error) {
                    if (error.response && error.response.data) {
                        toast.error(`${error.response.data.message}`);
                    } else if (error.request) {
                        toast.error('No response from server. Please try again later.');
                    } else {
                        toast.error(`Error: ${error.data.message}`);
                    }
                    }
                }}
                >
                {({ isSubmitting }) => (
                    <Form>
                    <div>
                        <TextInput
                        label='email'
                        name='email'
                        autoComplete='email'
                        type='email'
                        placeholder='Your email'
                        />
                    </div>
                    <Button 
                    type='submit' disabled={isSubmitting}
                    icon={<FaLongArrowAltRight/>}
                    >
                        {
                        isSubmitting ? <span className="loading loading-spinner loading-xs"></span> : <span>Reset Password</span>
                        }
                    </Button>
                    </Form>
                )}
            </Formik>
        </div>
    </div>
  )
}

export default InitiateResetPassword